<template>
    <div class="scc-container">
        <div class="scc-container__row">
            <div class="scc-container__column scc-container__lg-offset--2 scc-container__lg-column--8">
                <div class="scc-check-order">
                    <h1 class="scc-check-order__title">{{ title }}</h1>
                    <p class="scc-check-order__text">{{ text }}</p>
                    <p class="scc-check-order__share-text menu bold">{{ subText }}</p>
                    <div class="scc-check-order__socials">
                        <template v-for="social in socials">
                            <div :key="social.name" class="scc-check-order__social">
                                <ShareNetwork
                                    :network="social.name"
                                    :url="sharingUrl"
                                    :title="sharingTitle"
                                    :description="sharingText"
                                >
                                    <img :src="social.img" :alt="social.name + ' icon'" />
                                </ShareNetwork>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import './check-order.scss';

export default {
    name: 'CheckOrder',
    components: {},
    __editor: {
        fields: {
            backgroundColor: {
                widget: 'select',
                values: ['white', 'grey', 'primary', 'secondary'],
            },
            padding: {
                widget: 'select',
                values: ['none', 'small', 'medium', 'large'],
            },
        },
    },
    props: {
        checkStatus: {
            type: String,
            default: 'success',
            validator: function(val) {
                return ['loading', 'success', 'failed', 'error'].includes(val);
            },
        },
        loadingTitle: {
            type: String,
            default: 'Je aankoop wordt gecontroleerd',
        },
        loadingText: {
            type: String,
            default: '',
        },
        errorTitle: {
            type: String,
            default: 'Er is iets fout gegaan',
        },
        errorText: {
            type: String,
            default: '',
        },
        successTitle: {
            type: String,
            default: 'Bedankt voor je steun',
        },
        successText: {
            type: String,
            default: '',
        },
        failedTitle: {
            type: String,
            default: 'De aankoop is mislukt',
        },
        failedText: {
            type: String,
            default: '',
        },
        subText: {
            type: String,
            default: 'Deel dit met je vrienden:',
        },
        sharingTitle: {
            type: String,
            default: '',
        },
        sharingText: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            orderStatus: 'loading',
            sharingUrl: 'https://www.google.com',
            // sharingUrl: window.location.origin + '/aanmelden',
        };
    },
    computed: {
        title() {
            switch (this.orderStatus) {
                case 'success':
                    return this.successTitle;
                case 'failed':
                    return this.failedTitle;
                case 'error':
                    return this.errorTitle;
                default:
                    return this.loadingTitle;
            }
        },
        text() {
            switch (this.orderStatus) {
                case 'success':
                    return this.successText;
                case 'failed':
                    return this.failedText;
                case 'error':
                    return this.errorText;
                default:
                    return this.loadingText;
            }
        },
        socials() {
            let socialArray = ['facebook', 'twitter', 'linkedin', 'whatsapp'];
            let socials = [];

            socialArray.forEach(social => {
                socials.push({
                    name: social,
                    img: require(`@/assets/icons/${social}.svg`),
                });
            });
            return socials;
        },
    },
    created() {
        this.orderStatus = this.checkStatus;
    },
};
</script>
